import { anyType } from '@ardoq/global-consts';

/**
 * Display-only label for the `anyType` wildcard sentinel, which is overloaded
 * across two viewpoint-builder scenarios:
 *
 * - The default ("wildcard") viewpoint uses `anyType` for source/target/
 *   reference; those nodes read as "Any Type".
 * - The mixed-hierarchy start-set expansion swaps the concrete start node for a
 *   synthetic `anyType` "Context component type" node.
 *
 * The raw `anyType` sentinel is kept as the node's `metaData.label` so the
 * traversal still serialises the wildcard endpoint correctly to the backend;
 * this helper maps that sentinel to the right friendly label wherever the type
 * is shown to the user. `isHierarchyWildcardActive` (i.e. the start-set
 * expansion hierarchy node is in effect) decides which of the two labels to
 * use; concrete types always map to themselves.
 *
 * Not localised yet: the labels are expected to change while the feature is
 * behind the START_SET_EXPANSION_WITH_DESCENDANTS flag.
 */
export const COMPONENT_HIERARCHY_TYPE_LABEL = 'Context component type';
export const ANY_TYPE_LABEL = 'Any Type';

export const getComponentTypeDisplayLabel = (
  label: string,
  isHierarchyWildcardActive: boolean
): string => {
  if (label !== anyType) return label;
  return isHierarchyWildcardActive
    ? COMPONENT_HIERARCHY_TYPE_LABEL
    : ANY_TYPE_LABEL;
};
